import { getWideGroupListAdminsWidgetConfig } from '../../UserWidgets.deviation_gruser/GroupList/widgetConfig';
import { getMyBadgesWidgetConfig } from '../../UserWidgets.deviation_gruser/MyBadges/widgetConfig';
import { getStatsWidgetConfig } from '../../UserWidgets.deviation_gruser/Stats/widgetConfig';

export const getAboutSectionWidgetConfigs = ({ t, dispatch }) => ({
  topRight: {},
  midRight: { userstats: getStatsWidgetConfig({ t, dispatch }) },
  bottomRight: {
    groupListAdmins: getWideGroupListAdminsWidgetConfig({ t, dispatch }),
    badgesActivity: getMyBadgesWidgetConfig({ t, dispatch }),
  },
});
